import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["id"]
const _hoisted_9 = ["id"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["id"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["id"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { id: "thumbnailListAnchor" }, null, -1)
const _hoisted_16 = ["id"]
const _hoisted_17 = ["id"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "マイページ", -1)
const _hoisted_19 = ["id"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "コース選択", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "検索", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Thumbnail = _resolveComponent("Thumbnail")!
  const _component_User = _resolveComponent("User")!
  const _component_Tickets = _resolveComponent("Tickets")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      id: _ctx.$style.leftArea
    }, [
      _createVNode(_component_el_menu, {
        id: _ctx.$style.menu,
        "default-active": "2",
        class: "el-menu-vertical-demo"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_autocomplete, {
            modelValue: _ctx.state.autoCompleteValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.autoCompleteValue) = $event)),
            "fetch-suggestions": _ctx.querySearch,
            clearable: "",
            class: "inline-input w-50",
            onSelect: _ctx.search
          }, null, 8, ["modelValue", "fetch-suggestions", "onSelect"]),
          _hoisted_2,
          _createElementVNode("div", {
            id: _ctx.$style.searchButton
          }, [
            _createVNode(_component_el_button, {
              color: _ctx.BUTTON_COLOR,
              round: true,
              onClick: _ctx.search
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_SearchIcon)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["color", "onClick"])
          ], 8, _hoisted_3),
          _createVNode(_component_el_menu_item, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/user/mypage')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" マイページ ")
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.courseList, (course) => {
            return (_openBlock(), _createBlock(_component_el_menu_item, {
              key: course.id,
              onClick: ($event: any) => (_ctx.activeCourseChange(course))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(course.title), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["id"])
    ], 8, _hoisted_1),
    (_ctx.state.courseSelectorShowFlag)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: _ctx.$style.courseListSP
        }, [
          _createVNode(_component_el_menu, { "default-active": "2" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/user/mypage')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" マイページ ")
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.courseList, (course) => {
                return (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: course.id,
                  onClick: ($event: any) => (_ctx.activeCourseChange(course))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(course.title), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ], 8, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: _ctx.$style.rightArea
    }, [
      _createElementVNode("div", {
        id: _ctx.$style.planArea
      }, [
        _createElementVNode("p", {
          id: _ctx.$style.planTitle
        }, "現在受講中のコース", 8, _hoisted_7),
        _createElementVNode("div", {
          id: _ctx.$style.planContainer
        }, [
          _createElementVNode("div", {
            id: _ctx.$style.planTea,
            class: _normalizeClass(_ctx.$style.plan)
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.$style.plan_item_name)
            }, "茶道", 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.validPlan.tea, (plan) => {
              return (_openBlock(), _createElementBlock("p", {
                key: Number(plan.id)
              }, _toDisplayString(plan.title), 1))
            }), 128)),
            (!_ctx.state.validPlan.tea.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, "-"))
              : _createCommentVNode("", true)
          ], 10, _hoisted_9),
          _createElementVNode("div", {
            id: _ctx.$style.planKimono,
            class: _normalizeClass(_ctx.$style.plan)
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.$style.plan_item_name)
            }, "着付け", 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.validPlan.kimono, (plan) => {
              return (_openBlock(), _createElementBlock("p", {
                key: Number(plan.id)
              }, _toDisplayString(plan.title), 1))
            }), 128)),
            (!_ctx.state.validPlan.kimono.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, "-"))
              : _createCommentVNode("", true)
          ], 10, _hoisted_11),
          _createElementVNode("div", {
            id: _ctx.$style.planSweets,
            class: _normalizeClass(_ctx.$style.plan)
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.$style.plan_item_name)
            }, "和菓子", 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.validPlan.sweets, (plan) => {
              return (_openBlock(), _createElementBlock("p", {
                key: Number(plan.id)
              }, _toDisplayString(plan.title), 1))
            }), 128)),
            (!_ctx.state.validPlan.sweets.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, "-"))
              : _createCommentVNode("", true)
          ], 10, _hoisted_13)
        ], 8, _hoisted_8),
        _createElementVNode("p", null, [
          _createTextVNode(" 受講するプランを変更したい場合は "),
          _createVNode(_component_router_link, { to: "/video/subscription" }, {
            default: _withCtx(() => [
              _createTextVNode("こちら")
            ]),
            _: 1
          })
        ])
      ], 8, _hoisted_6),
      _hoisted_15,
      _createElementVNode("div", {
        id: _ctx.$style.videoContainer
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.activeVideoDataList, (videoData) => {
          return (_openBlock(), _createElementBlock("div", {
            key: videoData.imgSrc || '',
            class: _normalizeClass(_ctx.$style.video_item)
          }, [
            _createVNode(_component_Thumbnail, { "video-data": videoData }, null, 8, ["video-data"])
          ], 2))
        }), 128))
      ], 8, _hoisted_16),
      _createElementVNode("div", {
        id: _ctx.$style.menuSP
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.menu_item),
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.moveToMypage && _ctx.moveToMypage(...args)))
        }, [
          _hoisted_18,
          _createVNode(_component_el_icon, {
            class: _normalizeClass(_ctx.$style.menu_icon)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_User)
            ]),
            _: 1
          }, 8, ["class"])
        ], 2),
        _createElementVNode("div", {
          id: _ctx.$style.menuCourse,
          class: _normalizeClass(_ctx.$style.menu_item),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleCourseSelector && _ctx.toggleCourseSelector(...args)))
        }, [
          _hoisted_20,
          _createVNode(_component_el_icon, {
            class: _normalizeClass(_ctx.$style.menu_icon)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Tickets)
            ]),
            _: 1
          }, 8, ["class"])
        ], 10, _hoisted_19),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.menu_item),
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.moveToSearchSP && _ctx.moveToSearchSP(...args)))
        }, [
          _hoisted_21,
          _createVNode(_component_el_icon, {
            class: _normalizeClass(_ctx.$style.menu_icon)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SearchIcon)
            ]),
            _: 1
          }, 8, ["class"])
        ], 2)
      ], 8, _hoisted_17)
    ], 8, _hoisted_5)
  ]))
}